import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import {
  useCopyMapConfigMutation,
  useDeleteMapConfigByIdMutation,
  useLazyFetchMapsConfigsQuery,
} from '@redux/api/maps.api'

import { useHandlers } from '.'

export const useMapsConfigs = () => {
  const methods = useForm<{ searchPattern: string }>({ defaultValues: { searchPattern: '' } })
  const { watch } = methods
  const searchPattern = watch('searchPattern')

  const [idToDelete, setIdToDelete] = useState<number>()

  const [fetchMapsConfigs, { isLoading: isLoadingMapsConfigs, data: mapsConfigs }] =
    useLazyFetchMapsConfigsQuery()
  const [copyMapConfig, { isLoading: isCopyingMapConfig }] = useCopyMapConfigMutation()
  const [deleteMapConfig, { isLoading: isDeletingMapConfig }] = useDeleteMapConfigByIdMutation()

  const { state, handlers } = useHandlers({
    copyMapConfig,
    deleteMapConfig,
    isCopyingMapConfig,
    isDeletingMapConfig,
    setIdToDelete,
    idToDelete,
  })

  useEffect(() => {
    fetchMapsConfigs()
  }, [])

  return {
    state: {
      ...state,
      methods,
      isLoadingMapsConfigs,
      mapsConfigs,
      idToDelete,
    },
    handlers: {
      ...handlers,
    },
  }
}
